import React, { useState, useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';

import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, setIsSubmit, setSelectedAddress, setSelectedEntry, reportDWH, setPersonalInfo,reportAnalytics, setLeadPage, setDeliveryAddress, setErrorPage } from '../saleJetBlockSlice';
import { checkFiberAddressInfraStructure, getFirstTechnicianTimeAsync, getTechnicianTimesAsync, getCustomerAddresses, createWorkOrder, createLead, checkWhatsAppActivity , getAddressEntries, getDeliveryTimeSlots, filterOrCheckPackagesCorrect, getSalePricesAsync} from '../saleBlockAsyncThunk';
import AddressForm from '../Partials/AddressForm/AddressForm';
import CheckFiberStatus from '../Partials/CheckFiberStatus/CheckFiberStatus';
import InternetCheckFiberStatus from '../Partials/CheckFiberStatus/InternetCheckFiberStatus';
import EntryList from '../Partials/EntryList/EntryList';
import FoundFiberSuccess from '../Partials/FoundFiberSuccess/FoundFiberSuccess';
import InternetFoundFiberSuccess from '../Partials/FoundFiberSuccess/InternetFoundFiberSuccess';
import PackageDetails from '../Partials/PackageDetails/PackageDetails';
import EpiContext from '@episerver/spa-core/Spa';
import {gtag4} from '../../../../utilities/analytics/tracking';

const AddressPage = (props) => {
  const fiberList = ['FB', 'BF', 'BC'];
  const [step, setStep] = useState('AddressForm');
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    props.reportDWH({ actionType: 'Address Check', status: 'Ongoing', messageText: 'Address Check Page Displayed' });
    gtag4({
      event: `${props.saleType}_Step2_AddressPage`,
      step: props.isStartFromAddressPage ? '1' : '2',
      action: 'AddressPage',
      funnel_name: props.isStartFromAddressPage ? "Address_Check" : "Choose_Package",
    });
  }, []);

  // PackageDetails needs GetFullPrice data — load it when starting from package selection
  useEffect(() => {
    const shouldLoadPackagePrices =
      props.saleType === 'internet' &&
      !props.isStartFromAddressPage &&
      props.selectedPackageOfferId &&
      !props.hasPackagePriceDetails;

    if (shouldLoadPackagePrices) {
      props.getSalePricesAsync({ silent: true });
    }
  }, [props.saleType, props.isStartFromAddressPage, props.selectedPackageOfferId, props.hasPackagePriceDetails]);

  //page params
  let isDisplayFooter = false;
  let btnText = props.saleType == 'cellular' ? 'מעולה! אפשר להמשיך' : 'המשך';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  const isInternetSale = props.saleType == 'internet';
  const isCheckFiberAddress = props.saleType == 'internet' || props.saleType == 'triple';
  const showPackageDetails = isInternetSale && !props.isStartFromAddressPage && step === 'AddressForm';
  //page params

  let title = '';
  let subTitle = '';

  switch (step) {
    case 'AddressForm':
      if (props.saleType == 'tv') {
        title = 'מה הכתובת שלך?';
      }
      else if(props.saleType == 'cellular'){
        title = 'מה הכתובת?';
        subTitle = 'אנחנו צריכים אותה כדי לפתוח לך חשבון';
      }
      else if (props.saleType == 'internet') {
        title = 'היי, נתחיל מבדיקה זריזה\nאם יש סיבים בכתובת שלך';
      }
      else {
        title = 'נשמח לבדוק אם יש לך אינטרנט סיבים אופטיים בכתובת';
      }
      break;
    case 'CheckFiberStatus':
      title = '';
      subTitle = '';
      break;
    case 'EntryList':
      title = 'שמנו לב שיש בבניין שלך יותר מכניסה אחת';
      subTitle = 'מהי הכניסה שלך?';
      break;
    case 'FoundFiberSuccess':
      title = '';
      subTitle = '';
      break;
    default:
      title = '';
      subTitle = '';
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      {showPackageDetails && <PackageDetails />}
      {props.offerName && <h1 className='sale-title'></h1>}
      {title && <h1 className='sale-title-big'> {title} </h1>}
      {subTitle && <h2 className='sale-title-small'> {subTitle} </h2>}
    </div>
  );

  const jumpBetweenScreen = () => {
    switch (step) {
      case 'AddressForm':
        isDisplayFooter = true;
        if(props.saleType != 'cellular'){
          btnText = (isCheckFiberAddress ? 'חפשו את הכתובת שלי' : 'המשך');
        }
        return (
          <AddressForm
            isSubmit={props.isSubmit}
            onSubmit={handlePageValidate}
            selectedAddress={
              isInternetSale
                ? {
                    ...props.selectedAddress,
                    firstName: props.selectedAddress?.firstName ?? props.personalInfo?.firstName ?? '',
                    lastName: props.selectedAddress?.lastName ?? props.personalInfo?.lastName ?? '',
                    phoneNumber: props.selectedAddress?.phoneNumber ?? props.personalInfo?.subscriberNo ?? '',
                  }
                : props.selectedAddress
            }
            isInternetFiberForm={isInternetSale}
            displayFirstName={isInternetSale}
            displayLastName={isInternetSale}
            displayPhoneNumber={isInternetSale}
            displayPrivacyNotice={isInternetSale}
            hideFloor={isInternetSale}
          />
        );
      case 'CheckFiberStatus':
        isDisplayFooter = false;
        return isInternetSale
          ? <InternetCheckFiberStatus selectedAddress={props.selectedAddress} />
          : <CheckFiberStatus />;
      case 'EntryList':
        btnText = 'חפשו את הכתובת שלי';
        isDisplayFooter = true;
        return (
          <EntryList
            onSubmit={props.isSubmit}
            onValid={handlePageValidate}
            entries={entries}
            setSelectedEntry={handleSelectedEntry}
            selectedEntry={props.selectedEntry}
          />
        );
      case 'FoundFiberSuccess':
        isDisplayFooter = false;
        return isInternetSale ? (
          <InternetFoundFiberSuccess
            saleType={props.saleType}
            onSubmit={props.isSubmit}
            onValid={handlePageValidate}
            selectedAddress={props.selectedAddress}
            textsaleType={props.textsaleType}
          />
        ) : (
          <FoundFiberSuccess
            saleType={props.saleType}
            onSubmit={props.isSubmit}
            onValid={handlePageValidate}
            selectedAddress={props.selectedAddress}
          />
        );
      case 'LeadForm':
        //props.setLeadPage("noFiber");
        props.checkWhatsAppActivity();
        break;
    }
  };

  function handleSelectedEntry(entry) {
    props.setSelectedEntry(entry);
  }

  let currentPageView = (
    <div>
      {jumpBetweenScreen()}
    </div>
  );

  return (
    <div className={`slideAnimation${isInternetSale && step === 'AddressForm' ? ' internet-address-page' : ''}`}>
      {currentPageHeadline}
      <div className={`sale-page-content${isInternetSale && (step === 'FoundFiberSuccess' || step === 'CheckFiberStatus') ? ' full-width' : ''}`}>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );

  function handlePageContinue() {
    props.setIsSubmit(true);
  }

  async function handlePageValidate(data) {
    gtag4({
      event: `${props.saleType}_Step1_AddressPageContinueButton`,
      button: btnText,
      step: props.isStartFromAddressPage ? '1' : '2',
      action: 'AddressPageContinueButton',
      funnel_name: props.isStartFromAddressPage ? "Address_Check" : "Choose_Package",
    });
    props.setIsSubmit(false);
    switch (step) {
      case 'AddressForm':
        if (data.isValid) {
          props.setSelectedAddress(data.selectedAddress);
          if (isInternetSale) {
            props.setPersonalInfo({
              firstName: data.selectedAddress.firstName,
              lastName: data.selectedAddress.lastName,
              subscriberNo: data.selectedAddress.phoneNumber,
            });
          }

          if(props.saleType == 'cellular'){
            props.setDeliveryAddress(data.selectedAddress);
          }

          if (props.saleType == 'tv') {
            props.reportDWH({ actionType: 'Service Address', status: 'Ongoing', messageText: 'Service Address Button Clicked' });
          }
          else {
            if (props.saleType == 'triple') {
              props.reportAnalytics({ eventCategory: 'fibertv_process', eventAction: 'click_address_button', eventLabel: 'click_address_button' })
            }
            else if (props.saleType == 'internet') {
              props.reportAnalytics({ eventCategory: 'sivim_process', eventAction: 'click_address_button', eventLabel: 'click_address_button' })
            }
            props.reportDWH({ actionType: 'Address Check', status: 'Ongoing', messageText: 'Address Check Button Clicked' });
          }

          getAddressEntries();
        }
        break;
      case 'EntryList':
        if (data.valid) {
          afterSelectedEntry();
        }
        break;
      case 'FoundFiberSuccess':
        if (props.isStartFromAddressPage) {
          const resFilterPackages = await props.filterOrCheckPackagesCorrect();
          if(resFilterPackages.payload?.length > 0){
            props.goToPage('packagesPage');
          }else {
            props.setErrorPage({ isDisplay: true, id: '75', isOpenWorkOrder: true, description: 'אין חבילות להציג בהתאם לתשתית הקיימת' });
          }
        }
        else {
          props.getFirstTechnicianTimeAsync();
        }
        break;
    }
  }

  async function getAddressEntries(){
    const response = await props.getAddressEntries();
    const entryList = response.payload?.Body?.entryList;
    if (entryList != undefined && entryList?.length > 0) {
      setEntries(entryList);
      if (entryList.length == 1) {
        handleSelectedEntry(entryList[0]);
        afterSelectedEntry();
      } else {
        setStep('EntryList');
      }
    }
    else{
      goToNoFiberLead('There is no entries');
    }
  }

  function afterSelectedEntry(){
    props.reportDWH({ actionType: 'Address Check', status: 'Ongoing', messageText: 'Entrance Popup Button Clicked' });
    if (isCheckFiberAddress) {
      setStep('CheckFiberStatus');
      getFiberAddressInfraStructure();
    }
    else {
      if(props.saleType == 'cellular'){
        if(props.cellular.isDisplayDeliveryPage){
          props.getDeliveryTimeSlots();
        }
        else{
          props.goToPage('summaryPage');
        }
      }
      else{
        //this check is for TV only
        const converters = props.saleCatalog.converters.filter(x => x.action == 'Add');
        if (converters.length > 0) {
          props.getTechnicianTimesAsync();
        }
        else {
          if (props.flowType == 'existsCustomer') {
            props.getCustomerAddresses();
          }
          else {
            props.goToPage('personalInfoPage');
          }
        }
      }
    }
  }

  async function getFiberAddressInfraStructure(){
    const response = await props.checkFiberAddressInfraStructure();
    const entryList = response.payload?.Body?.entryList;
    if (entryList != undefined && entryList?.length > 0) {
      const selected_entry = entryList.length == 1 ? entryList[0] :  entryList.find(x => x.entry == props.selectedEntry.entry);
      handleSelectedEntry(selected_entry);
      if (fiberList.includes(selected_entry.infrastructure)) {
        setStep('FoundFiberSuccess');
        props.reportDWH({ actionType: 'Address Check', status: 'Ongoing', messageText: 'Fiber Connected There' });
      } else {
        goToNoFiberLead('Fiber Not Connected There');
      }
    } else {
      goToNoFiberLead('Fiber Not Connected There');
    }
  }

  function goToNoFiberLead(messageText) {
    props.reportDWH({ actionType: 'Address Check', status: 'Ongoing', messageText });
    if (isInternetSale) {
      props.setLeadPage('noFiber');
      return;
    }
    setStep('LeadForm');
  }



  function handleSubmit(event) {
    event.preventDefault();
  }
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
    isSubmit: state.saleJetBlock.isSubmit,
    selectedEntry: state.saleJetBlock.addressPage.selectedEntry,
    selectedAddress: state.saleJetBlock.addressPage.selectedAddress,
    personalInfo: state.saleJetBlock.personalInfo,
    saleCatalog: state.saleJetBlock.saleCatalog,
    allPackeges: state.saleJetBlock,
    // technology: state.saleJetBlock.addressPage.selectedEntry?.technologyType,
    selectPackgeUser: state.saleBlockData?.selectedPackage,
    isStartFromAddressPage: state.saleJetBlock.saleBlockData.isStartFromAddressPage,
    textsaleType: state.saleJetBlock.saleBlockData.textsaleType,
    cellular: state.saleJetBlock.cellular,
    selectedPackageOfferId: state.saleJetBlock.selectedPackage?.offerId,
    hasPackagePriceDetails: Boolean(state.saleJetBlock.summaryDetails?.shoppingCart?.fullPrice?.length),
  };
};

const mapDispatchToProps = {
  goToPage,
  setIsSubmit,
  setSelectedAddress,
  checkFiberAddressInfraStructure,
  getAddressEntries,
  setSelectedEntry,
  getFirstTechnicianTimeAsync,
  getTechnicianTimesAsync,
  getCustomerAddresses,
  reportDWH,
  createWorkOrder,
  setPersonalInfo,
  setLeadPage,
  createLead,
  reportAnalytics,
  checkWhatsAppActivity,
  getDeliveryTimeSlots,
  setDeliveryAddress,
  filterOrCheckPackagesCorrect,
  setErrorPage,
  getSalePricesAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressPage);
